import { render } from "./admin-organizations.vue?vue&type=template&id=782bf5c8&ts=true&lang=pug"
import script from "./admin-organizations.vue?vue&type=script&lang=ts"
export * from "./admin-organizations.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__